import JSONApiService from "@/services/JSONApiService";
import {
  ORGANISATION_MODEL,
  organisationModelActions
} from "@/models/organisation-model";
import { disablePluralizeForCall } from "@/services/utils";
import { include, PARENT } from "@/models/relationships";
import {
  ORGANISATIONS_MODEL,
  SCOPE_USERS,
  SCOPE_USERS_PREVIEW
} from "@/models/organisation-model";

const { PUBLISH, ARCHIVE, DUPLICATE, RESTORE } = organisationModelActions;

const callOrganisationUnitAction = ({ id, action, commit }) => {
  const api = JSONApiService(commit);
  api.one(ORGANISATION_MODEL, id);
  disablePluralizeForCall(api, () => api.all(action));
  return api.patch({});
};

const organisationApi = commit => ({
  getAll: async params =>
    JSONApiService(commit)
      .all(ORGANISATION_MODEL)
      .get({ ...params, ...include(PARENT) }),
  getAllNoParents: async params =>
    JSONApiService(commit)
      .all(ORGANISATION_MODEL)
      .get({ ...params }),
  archiveOrganisationUnit: async id =>
    callOrganisationUnitAction({
      id,
      action: ARCHIVE,
      commit
    }),
  deleteDraftOrganisationUnit: async id =>
    JSONApiService(commit)
      .one(ORGANISATION_MODEL, id)
      .destroy(),
  duplicateOrganisationUnit: async id =>
    callOrganisationUnitAction({
      id,
      action: DUPLICATE,
      commit
    }),
  publishOrganisationUnit: async id =>
    callOrganisationUnitAction({
      id,
      action: PUBLISH,
      commit
    }),
  restoreOrganisationUnit: async ({ id, parentId }) => {
    const api = JSONApiService(commit);
    api.one(ORGANISATION_MODEL, id);
    disablePluralizeForCall(api, () => api.all(RESTORE));
    return api.post({ parentId });
  },
  editOrganisationUnit: async ({ organisation, id }) =>
    JSONApiService(commit)
      .one(ORGANISATION_MODEL, id)
      .patch(organisation),
  createOrganisationUnit: async data =>
    JSONApiService(commit)
      .all(ORGANISATION_MODEL)
      .post(data),
  getScopedUsers: async id =>
    JSONApiService(commit)
      .one(ORGANISATIONS_MODEL, id)
      .all(SCOPE_USERS)
      .get(),
  getScopedUsersPreview: async ({ id, params }) => {
    const api = JSONApiService(commit);
    api.one(ORGANISATION_MODEL, id);
    disablePluralizeForCall(api, () => api.all(SCOPE_USERS_PREVIEW));
    return api.get(params);
  }
});

export default organisationApi;
